<template>
  <div class="preview">
    <div class="preview-title">
      <div class="preview-title__text">
        <span>奖品发放总览</span>
      </div>
    </div>
    <div class="preview-list">
      <div class="preview-list-item" v-for="item in list" :key="item.id">
        <div class="preview-list-item-left">
          <img :src="getPrizeLogo(item)" alt="">
        </div>
        <div class="preview-list-item-right">
          <div class="preview-list-item-right__item">
            <div class="preview-list-item-right__item__label">
                <span>奖品名称：</span>
                <span>{{getPrizeName(item)}}</span>
            </div>
            <span class="preview-list-item-right__item__tag">{{item.prizeType | prizeType}}</span>
          </div>
          <div class="preview-list-item-right__item">
            <div class="preview-list-item-right__item__label">
              <span>已发放：</span>
              <span class="preview-list-item-right__item__label__value">{{item.sendAmount}}</span>
            </div>
            <div>
              <span>已发放价值：</span>
              <span>{{item.sendSumPrice}}</span>
            </div>
          </div>
          <div class="preview-list-item-right__item">
            <span>剩余/总量：</span>
            <span>{{item.remanentAmount}}/{{item.totalAmount}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prizeSum } from "@/api/integralCenter/PointActivityAnalyticController";
import cash from "@/assets/images/integralCenter/prize/cash.png"
import coupon from "@/assets/images/integralCenter/prize/coupon.png"
import e_card from "@/assets/images/integralCenter/prize/e_card.png"
import i_member from "@/assets/images/integralCenter/prize/i_member.png"
import jingdou from "@/assets/images/integralCenter/prize/jingdou.png"
import plus_member from "@/assets/images/integralCenter/prize/plus_member.png"
import store_points from "@/assets/images/integralCenter/prize/store_points.png"
export default {
  props:{
    activityId:{
      type:String
    }
  },
  data(){
    return {
      time:null,
      priceImg:'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/prizeShow.png',//默认产品图
      list:[]
    }
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      }
      return result;
    },
  },
  computed: {
    // 奖品名称
    getPrizeName(){
      return (item)=>{
        const name  = this.$options.filters.prizeType(item.prizeType)
        if(item.prizeType == 1 || item.prizeType == 2 || item.prizeType == 3 ||item.prizeType == 4 || item.prizeType == 8 || item.prizeType == 10){
          return item.title
        }else{
          return name
        }
      }
    },
    // 奖品logo
    getPrizeLogo(){
      return (item)=>{
        if(item.logo){
          return item.logo
        }else{
          if(item.prizeType == 1){
            return coupon
          }else if(item.prizeType == 2){
            return jingdou
          }else if(item.prizeType == 4){
            return store_points
          }else if(item.prizeType == 5){
            return e_card
          }else if(item.prizeType == 6){
            return i_member
          }else if(item.prizeType == 7){
            return plus_member
          }else if(item.prizeType == 8){
            return cash
          }
        }
      }
    }
  },
  created(){
    this.getList()
  },
  methods:{
    getList(){
      prizeSum({activityId:this.activityId}).then(res=>{
        this.list = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.preview{
  &-title{
    display: flex;
    align-items: center;
    &__text{
      font-weight: bold;
      margin-right: 16px;
    }
  }
  &-list{
    display: flex;
    flex-wrap: nowrap;
    margin: 16px 0px;
    overflow-x: auto;
    &-item{
      display: flex;
      align-items: center;
      padding: 20px 16px;
      border: 1px solid #eee;
      border-radius: 2px;
      flex:0 0 auto;
      margin-right: 20px;
      &-left{
        width:80px;
        height: 80px;
        margin-right: 10px;
        img{
          width:100%;
          height:100%;
          border-radius: 2px;
        }
      }
      &-right{
        display: flex;
        flex-direction: column;
        &__item{
          display: flex;
          align-items: center;
          padding-top: 16px;
          &:first-child{
            padding-top: 0px;
          }
          &__label{
            margin-right: 30px;
            &__value{
              font-weight: bold;
            }
          }
          &__tag{
            background: rgba(39, 104, 255, 0.1);
            color: #7B61FF;
            border: 1px solid #7B61FF;
            padding: 4px 8px;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>